import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
import CustomButton from "../components/Button";
import CustomCardList from "../components/Cards";
import CustomDatePicker from "../components/CustomDatePicker";
import PageLoader from "../components/Loader";
import Title from "../components/PageTitle";
import SearchableDropdown from "../components/SearchableDropdown";
import TestTypeSelect from "../components/TestTypeSelect";
import CustomTable from "../components/Table";
import { useToast } from "../components/Toast";
const Users = () => {
  const isMobile = useIsMobile();
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [userCount, setUsersCount] = useState(0);
  const [Loader, isLoader] = useState(false);
  const token = localStorage.getItem("token");
  const Toast = useToast();
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [allDoctors, setAllDoctors] = useState([]);
  const [allClinic, setAllClinics] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  // Initialize states from URL params
  const [searchQuery, setSearchQuery] = useState(searchParams.get("q") || "");
  const [selectedDocor, setSelectedDoctor] = useState(
    JSON.parse(searchParams.get("doctor") || "[]")
  );
  const [selectedClinic, setSelectedClinic] = useState(
    JSON.parse(searchParams.get("clinic") || "[]")
  );
  const [selectedSources, setSelectedSources] = useState(
    JSON.parse(searchParams.get("source") || "[]")
  );
  const [testType, setTestType] = useState(searchParams.get("scanType") || "");
  const [testStartDate, setTestStartDate] = useState(
    searchParams.get("start") || null
  );
  const [testEndDate, setTestEndDate] = useState(
    searchParams.get("end") || null
  );

  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const [rowsPerPage, setRowsPerPage] = useState(
    Number(searchParams.get("limit")) || 10
  );
  const navigate = useNavigate();
  const updateURLParams = (newFilters) => {
    setSearchParams({
      q: newFilters.searchQuery || "",
      doctor: JSON.stringify(newFilters.selectedDocor || []),
      clinic: JSON.stringify(newFilters.selectedClinic || []),
      source: JSON.stringify(newFilters.selectedSources || []),
      scanType: newFilters.testType || "",
      start: newFilters.testStartDate || "",
      end: newFilters.testEndDate || "",
      page: newFilters.page || 1,
      limit: newFilters.rowsPerPage || 10,
    });
  };

  useEffect(() => {
    dropDownData();
    if (typingTimeout) clearTimeout(typingTimeout);
    const timeout = setTimeout(() => {
      const doctorIds = selectedDocor.map((doc) => doc._id);
      const clinicIds = selectedClinic.map((clinic) => clinic._id);
      const selectedSource = selectedSources.map((source) => source.value);
      getUsers(
        page,
        rowsPerPage,
        doctorIds,
        clinicIds,
        searchQuery,
        testStartDate,
        testEndDate,
        selectedSource,
        testType
      );
    }, 500); // debounce for typing

    setTypingTimeout(timeout);

    return () => clearTimeout(timeout);
  }, [
    searchQuery,
    selectedDocor,
    selectedClinic,
    selectedSources,
    testType,
    page,
    rowsPerPage,
    testStartDate,
    testEndDate,
  ]);
  useEffect(() => {
    updateURLParams({
      searchQuery,
      selectedDocor,
      selectedClinic,
      selectedSources,
      testType,
      testStartDate,
      testEndDate,
      page,
      rowsPerPage,
    });
  }, [
    searchQuery,
    selectedDocor,
    selectedClinic,
    selectedSources,
    testType,
    testStartDate,
    testEndDate,
    page,
    rowsPerPage,
  ]);

  const dropDownData = async (doctorKeyword, clinicKeyword) => {
    try {
      const res = await apiService.fetchDoctorAndClinics(
        doctorKeyword,
        clinicKeyword,
        token
      );
      setAllDoctors(res.data.doctors);
      setAllClinics(res.data.clinics);
    } catch (error) {
      Toast.error("Error while Fetching dropdowndata");
    }
  };
  const getUsers = async (
    page,
    limit,
    doctorIds = [],
    clinicIds = [],
    keyword = "",
    testStartDate,
    testEndDate,
    sourceFilter = [],
    testType = ""
  ) => {
    isLoader(true);
    try {
      const { mapped, count } = await apiService.fetchUsers(
        token,
        page,
        limit,
        doctorIds,
        clinicIds,
        keyword,
        testStartDate,
        testEndDate,
        sourceFilter,
        testType
      );

      setFilteredUsers(mapped);
      setUsersCount(count);
    } catch (error) {
      Toast.error("Error while Fetching users");
    } finally {
      isLoader(false);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1); // Set the new page
  };
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10)); // Update rows per page when changed
    setPage(1); // Reset to page 1 when rows per page change
  };

  const handleSearch = (event) => {
    const keyword = event.target.value.toLowerCase();
    setSearchQuery(keyword); // Only set the query
  };

  const fields = [
    { label: "Name", key: "name" },
    { label: "mobile", key: "mobile" },
  ];
  const Source = {
    other: "Other",
    App: "App",
    Kiosk: "Kiosk",
    WhatsApp: "WhatsApp",
    Engage: "Engage",
    Helpline: "Helpline",
  };
  const getStatusStyles = (status) => {
    switch (status) {
      case Source.other:
        return { color: "red" };
      case Source.App:
        return { color: "#002446" };
      case Source.Kiosk:
        return { color: "#874EF6" };
      case Source.WhatsApp:
        return { color: "#green" };
      case Source.Engage:
        return { color: "#2544a1" };
      case Source.Helpline:
        return { color: "#b06b9d" };
      default:
        return { color: "#888" };
    }
  };
  const columns = [
    {
      field: "name",
      headerName: "Name",
      align: "center",
    },
    {
      field: "doctor",
      headerName: "Associate doctor",
      align: "center",
    },
    {
      field: "countryCode",
      headerName: "Country Code",
      align: "center",
    },
    {
      field: "mobile",
      headerName: "Mobile",
      align: "center",
    },
    {
      field: "source",
      headerName: "Source",
      align: "center",
      renderCell: (value) => {
        const status = value; // Get the value from the params object
        const styles = getStatusStyles(status); // Get the styles based on the status

        return (
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1rem",
              ...styles,
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      field: "testDate", // match exactly with your data field name
      headerName: "Updated at",
      align: "center",
      renderCell: (params) => {
        const rawDate = params;
        if (!rawDate) return "--";

        const date = new Date(rawDate);
        const formattedDate = date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        return (
          <span style={{ fontSize: "1rem", fontWeight: "500" }}>
            {formattedDate}
          </span>
        );
      },
    },
  ];

  const detailsClick = (uid, mobile, name, source, doctor) => {
    navigate(`/dashboard/user/${uid}`, {
      state: { uid, mobile, name, source, doctor, testType },
    });
  };
  const sourceOptions = [
    { label: "App", value: "App" },
    { label: "Kiosk", value: "Kiosk" },
    { label: "WhatsApp", value: "WhatsApp" },
    { label: "Helpline", value: "Helpline" },
    { label: "Engage", value: "Engage" },
    { label: "Other", value: "Other" },
  ];

  return (
    <Paper sx={{ padding: 2 }}>
      <Title text="Patients" />

      <Box display="flex" alignItems="center" gap={2}>
        <SearchableDropdown
          width={1 / 3}
          label="Doctors"
          options={allDoctors}
          selectedOptions={selectedDocor}
          onChange={setSelectedDoctor}
          getOptionLabel={(option) => option.name}
          getOptionKey={(option) => option._id}
        />

        <SearchableDropdown
          width={1 / 3}
          label="Clinics"
          options={allClinic}
          selectedOptions={selectedClinic}
          onChange={setSelectedClinic}
          getOptionLabel={(option) => option.name}
          getOptionKey={(option) => option._id}
        />
        <SearchableDropdown
          width={1 / 3}
          label="Source"
          options={sourceOptions}
          selectedOptions={selectedSources}
          onChange={setSelectedSources}
          getOptionLabel={(option) => option.label}
          getOptionKey={(option) => option.value}
        />
      </Box>
      <Box display="flex" alignItems="center" gap={2} mt={2}>
        <Box display="flex" gap={4} flex={2}>
          <CustomDatePicker
            selectedDate={testStartDate ? new Date(testStartDate) : null}
            handleDateChange={(date) => {
              const formatted = date.toISOString().split("T")[0];
              setTestStartDate(formatted);
            }}
            label={"Test Start Date"}
            isDocEditable={true}
          />

          <CustomDatePicker
            selectedDate={testEndDate ? new Date(testEndDate) : null}
            handleDateChange={(date) => {
              const formatted = date.toISOString().split("T")[0];
              setTestEndDate(formatted);
            }}
            label={"Test End Date"}
            isDocEditable={true}
          />

          <TestTypeSelect
            value={testType}
            onChange={(value) => {
              setTestType(value);
              setPage(1);
            }}
          />
        </Box>

        <Box flex={1} display="flex" justifyContent="flex-end">
          <CustomButton
            text={"Clear filter"}
            variant="outlined"
            onClick={() => {
              setSelectedDoctor([]);
              setSelectedClinic([]);
              setSelectedSources([]);
              setTestType("");
              setSearchQuery("");
              setTestEndDate("");
              setTestStartDate("");
              getUsers(page, rowsPerPage, [], [], "", "", "", []);
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginBottom: 2,
        }}
      >
        <TextField
          label="Search"
          variant="outlined"
          value={searchQuery}
          onChange={handleSearch}
          fullWidth
          sx={{ marginBottom: 2, marginTop: 3 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {isMobile ? (
        // Card layout for mobile
        <CustomCardList
          page={page - 1} // Adjust for zero-based indexing for `CustomTable`
          rowsPerPage={rowsPerPage}
          totalCount={userCount}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          fields={fields}
          data={filteredUsers}
          onCardClick={(row) =>
            detailsClick(row.uid, row.mobile, row.name, row.source, row.doctor)
          }
        />
      ) : (
        <CustomTable
          columns={columns}
          data={filteredUsers}
          onRowClick={(row) =>
            detailsClick(row.uid, row.mobile, row.name, row.source, row.doctor)
          }
          actions={[
            {
              Component: CustomButton,
              props: { text: "Details", width: "90px", height: "40px" },
              onClick: (row) =>
                detailsClick(
                  row.uid,
                  row.mobile,
                  row.name,
                  row.source,
                  row.doctor
                ),
            },
          ]}
          page={page - 1} // Adjust for zero-based indexing for `CustomTable`
          rowsPerPage={rowsPerPage}
          totalCount={userCount}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}
      {Loader && <PageLoader />}
    </Paper>
  );
};
export default Users;
